module.exports = __webpack_public_path__ + "img/born.8cbc1ad0.jpg";